// AuthProvider.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged, signInAnonymously } from 'firebase/auth';
import { app } from './firebaseConfig';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user,    setUser]    = useState(null);
    const [loading, setLoading] = useState(true);
    const auth = getAuth(app);

    useEffect(() => {
        // 1) Auto-sign in every visitor
        signInAnonymously(auth).catch(err => {
            console.error("Anonymous auth failed", err);
            setLoading(false);
        });

        // 2) Wait for auth state
        const unsubscribe = onAuthStateChanged(auth, u => {
            setUser(u);
            setLoading(false);
        });
        return unsubscribe;
    }, [auth]);

    return (
        <AuthContext.Provider value={{ user }}>
            {!loading && children}
        </AuthContext.Provider>
    );
};
